var formsHelper = require('../../utils/forms_helper');

/* eslint-disable complexity */
/* eslint-disable max-len */
/* eslint-disable max-statements */
window.registerFormChange = function(source, sourceValue, sourceType, operator, target) {
  'use strict';
  var $target;

  if (!source && !sourceValue && !sourceType && !operator && !target) {
    return false;
  }

  $target = jQuery('input[name=\'' + target + '\'], textarea[name=\'' + target + '\'], select[name=\'' + target + '\'], label[name=\'' + target + '\'], .ipo-mdc-form-conditional#' + target);

  if ($target.length > 0) {
    // Target is form element
    if ((sourceType === 'checkboxGroup' || sourceType === 'checkbox') && !isSummarySource(source)) {
      handleCheckbox(source, sourceValue, operator, function() { showField($target); }, function() { hideField($target); });
    } else {
      formElementChange(source, sourceType, sourceValue, operator, function() { showField($target); }, function() { hideField($target); });
    }
  }
  else {
    // Target is not form element -> check if subgroup exists
    $target = jQuery('div.ipo-mdc-form__subgroup#' + target);
    if ($target.length > 0) {
      if ((sourceType === 'checkboxGroup' || sourceType === 'checkbox') && !isSummarySource(source)) {
        handleCheckbox(source, sourceValue, operator, function() { showSubgroup($target); }, function() { hideSubgroup($target); });
      } else {
        formElementChange(source, sourceType, sourceValue, operator, function() { showSubgroup($target); }, function() { hideSubgroup($target); });
      }
    }
  } 

  function isSummarySource(source) {
    var $source;

    $source = jQuery('input[name=\'' + source + '\']');
    return $source.length > 0 && isSummaryField($source);
  }

  function isSummaryField(field) {
    return field.attr('type') === 'hidden';
  }

  function isCheckboxChecked(checkbox, operator, showCallback, hideCallback) {
    var result = jQuery(checkbox).is(':checked');

    if ((operator === 'eq' && result) || (operator === 'neq' && !result)) {
      showCallback();
    } else {
      hideCallback();
    }
  }

  function handleCheckbox(source, sourceValue, operator, showCallback, hideCallback) {
    var $source, i, formField, label;

    $source = jQuery('input[name=\'' + source + '\']').filter('[type="checkbox"]');
    if ($source.length) {
      for (i = 0; i < $source.length; i++) {
        formField = jQuery($source[i]).closest('.mdc-form-field');
        label = formField.find('.ipo-mdc-checkbox__label-title');
        if (label.length === 0) {
          label = formField.find('label');
        }

        if (label.html() === sourceValue) {
          isCheckboxChecked($source[i], operator, showCallback, hideCallback);
          jQuery($source[i]).on('change', function() {
            isCheckboxChecked(this, operator, showCallback, hideCallback);
          });
        }
      }
    }
  }

  function validateFormValue($source, sourceType, sourceValue, operator, showCallback, hideCallback) {
    var targetValue, regExp, result;

    if (sourceType === 'radio' && !isSummaryField($source)) {
      targetValue = $source.filter(':checked').val();
    } else {
      targetValue = $source.val();
    }

    if (targetValue == undefined || targetValue == '') {
      hideCallback();
      return;
    }

    regExp = new RegExp('^' + sourceValue.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') + '$', 'i');
    result = regExp.test(targetValue);

    if ((operator === 'eq' && result) || (operator === 'neq' && !result)) {
      showCallback();
    } else {
      hideCallback();
    }
  }

  function formElementChange(source, sourceType, sourceValue, operator, showCallback, hideCallback) {
    var $source = jQuery('input[name=\'' + source + '\'], textarea[name=\'' + source + '\'], select[name=\'' + source + '\']');

    if ($source.length) {
      validateFormValue($source, sourceType, sourceValue, operator, showCallback, hideCallback);
      $source.on('change', function() {
        validateFormValue($(this), sourceType, sourceValue, operator, showCallback, hideCallback);
      });
    }
  }

  function showSubgroup(element) {
    if (!element || !element.hasClass('ipo-mdc-form__subgroup--hidden')) {
      return;
    }

    element.find('.ipo-mdc-form__field-container').each(function() {
      var $source, $target, sourceId, sourceValue, sourceType, operator, targetKey;

      if (jQuery(this).data('conditional-isconditional')) {
        sourceId = element.data('conditional-sourceid');
        sourceValue = element.data('conditional-sourcevalue');
        sourceType = element.data('conditional-sourcetype');
        operator = element.data('conditional-operator');
        targetKey = element.data('conditional-targetkey');
        $source = jQuery('input[name=\'' + sourceId + '\'], textarea[name=\'' + sourceId + '\'], select[name=\'' + sourceId + '\']');
        $target = jQuery('input[name=\'' + targetKey + '\'], textarea[name=\'' + targetKey + '\'], select[name=\'' + targetKey + '\'], label[name=\'' + targetKey + '\'], .ipo-mdc-form-conditional#' + target);
        validateFormValue($source, sourceType, sourceValue, operator, function() { showField($target); }, function() { hideField($target); });
      } else {
        jQuery(this).find('input[name], textarea[name], select[name], .ipo-mdc-form-conditional').each(function() {
          showField($(this));
        });
      }
    });

    element.removeClass('ipo-mdc-form__subgroup--hidden');
  }

  function showField(element) {
    if (!element) {
      return;
    }

    enableField(element);
    element.closest('.ipo-mdc-form__field-container').removeClass('ipo-mdc-form__field-container--hidden');
    checkFormIsEnabled(element);
  }

  function enableField(element) {
    var formfield;

    if (!element) {
      return;
    }

    element.prop('disabled', false);
    formfield = element.closest('.mdc-text-field, .mdc-select');
    if (formfield && formfield.length > 0) {
      if (formfield.hasClass('mdc-text-field')) {
        formfield.removeClass('mdc-text-field--disabled');
      }
      if (formfield.hasClass('mdc-select')) {
        formfield.removeClass('mdc-select--disabled');
      }
    }
  }

  function hideSubgroup(element) {
    if (!element || element.hasClass('ipo-mdc-form__subgroup--hidden')) {
      return;
    }

    element.find('.ipo-mdc-form__field-container').each(function() {
      hideField(jQuery(this).find('input[name], textarea[name], select[name], .ipo-mdc-form-conditional'));
    });

    element.addClass('ipo-mdc-form__subgroup--hidden');
  }

  function hideField(element) {
    var container;

    if (!element) {
      return;
    }

    container = element.closest('.ipo-mdc-form__field-container');
    if (container.hasClass('ipo-mdc-form__field-container--hidden')) {
      return;
    }

    clearField(element);
    disableField(element);
    element.closest('.ipo-mdc-form__field-container').addClass('ipo-mdc-form__field-container--hidden');

    checkFormIsEnabled(element);
  }

  function disableField(element) {
    var formfield;

    if (!element) {
      return;
    }

    element.prop('disabled', true);
    formfield = element.closest('.mdc-text-field, .mdc-select');
    if (formfield && formfield.length > 0) {
      if (formfield.hasClass('mdc-text-field')) {
        formfield.addClass('mdc-text-field--disabled');
      }
      if (formfield.hasClass('mdc-select')) {
        formfield.addClass('mdc-select--disabled');
      }
    }
    formsHelper.reInitForms();
  }

  function clearField(element) {
    var mdcElement, type;

    if (!element) {
      return;
    }

    // Reset validation
    if (element.length > 0) {
      element.each(function() {
        mdcElement = window.form.getFormField(this);
        if (mdcElement) {
          mdcElement.trailingIconContent = null;

          type = $(this).attr('type');
          if (type === 'checkbox' || type === 'radio') {
            mdcElement.checked = false;
          } else {
            mdcElement.value = '';
          }

          element.trigger('change');
        }
      });
    }
  }

  function checkFormIsEnabled(element) {
    var activeStopElements, form;

    if (element.hasClass('ipo-mdc-form-stop-element')) {
      form = element.closest('.ipo-mdc-form');
      activeStopElements = form.find('.ipo-mdc-form__subgroup:not(.ipo-mdc-form__subgroup-hidden) .ipo-mdc-form__field-container:not(.ipo-mdc-form__field-container--hidden) .ipo-mdc-form-stop-element');
      if (activeStopElements.length > 0) {
        form.addClass('ipo-mdc-form--no-submit');
      } else {
        form.removeClass('ipo-mdc-form--no-submit');
      }
    }
  }
};

jQuery(document).ready(function($) {
  'use strict';

  jQuery('.ipo-mdc-form div[data-conditional-isconditional=\'true\']').each(function() {
    registerFormChange(jQuery(this).data('conditional-sourceid'),
    jQuery(this).data('conditional-sourcevalue'),
    jQuery(this).data('conditional-sourcetype'),
    jQuery(this).data('conditional-operator'),
    jQuery(this).data('conditional-targetkey'));
  });
});
